import { Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { ApiRequestStatus } from "../../app/enums/apiRequestStatus";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useAppSelector } from "../../app/store/configureStore";
import { useEffect, useState } from "react";
import { MESSAGE_PROCESSING_DETAILS } from "../../app/utils/constant";
import { useGetCreditSummary } from "../../app/customHooks/useGetCreditSummary";
import { SummaryDto } from "../../app/models/pcs/summaryDto";
import LegacySummaryTable from "./LegacySummaryTable";
import SummaryTable from "./SummaryTable";

export default function SummaryForm() {
    const queryParams = new URLSearchParams(window.location.search);
    const personId = queryParams.get("personId");

    const { summaryData, legacySummaryData, getCreditSummaryStatus } = useAppSelector(state => state.pcs);

    useGetCreditSummary(personId);

    const [isYearPartialyCompleted, setIsYearPartialyCompleted] = useState<boolean>(false);
    const [isLegacyYearPartialyCompleted, setIsLegacyYearPartialyCompleted] = useState<boolean>(false);
    const [totalOfSummary, setTotalOfSummary] = useState<number[]>([]);

    useEffect(() => {
        if (summaryData) {
            let totalSummary: number[] = [];
            summaryData.map((item: SummaryDto[]) => {
                let isYearPartialyComplete = false;
                if (item[2].text.toLowerCase() === "true" && isYearPartialyComplete === false) {
                    setIsYearPartialyCompleted(true);
                }
                totalSummary.push(parseFloat(item[3].text.split(' (')[0]) + parseFloat(item[4].text.split(' (')[0]) + parseFloat(item[5].text.split(' (')[0]) + parseFloat(item[6].text.split(' (')[0]));
            });
            setTotalOfSummary(totalSummary);
        }
    }, [summaryData]);

    useEffect(() => {
        if (legacySummaryData) {
            legacySummaryData.map((item: SummaryDto[]) => {
                if (item[1].text.toLowerCase() === "true") {
                    setIsLegacyYearPartialyCompleted(true);
                }
            });
        }
    }, [legacySummaryData]);

    if (getCreditSummaryStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return (<>
        <Box sx={{ minWidth: "100%" }} component={Paper}>

            <Grid container rowSpacing={4}>

                <Grid item xs={12} sx={{ marginLeft: '2%', marginTop: '2%' }}>
                    <Typography variant='h4'>6 Year Summary</Typography>
                </Grid>

                <Grid item xs={12}></Grid>

            </Grid>
        </Box>

        <SummaryTable sixYearSummaryData={summaryData} totalOfSummary={totalOfSummary} isYearPartialyCompleted={isYearPartialyCompleted} />

        {legacySummaryData && legacySummaryData?.length > 0 && <>
            <Box sx={{ minWidth: "100%" }} component={Paper}>
                <Grid container rowSpacing={4}>
                    <Grid item xs={12} sx={{ marginLeft: '2%', marginTop: '2%' }}>
                        <Typography variant='h4'>Pre 2025 summary</Typography>
                    </Grid>
                    <Grid item xs={12}></Grid>
                </Grid>
            </Box>

            <LegacySummaryTable legacySixYearSummaryData={legacySummaryData} isLegacyYearPartialyCompleted={isLegacyYearPartialyCompleted} />
        </>}
    </>)
}